class MassiveSmartGeocodeCollection extends App.Collections.BaseCollection {
    url = 'MassiveSmartGeocode/MassiveSmartGeocodeResult';
    model = App.Models.MassiveSmartGeocode;

    getPositionByLocationId = (locationId) => {
        const typeOfLocationId = typeof locationId;

        if (typeOfLocationId !== "undefined") {
            const length = this.size();

            if (typeOfLocationId === "string") {
                locationId = parseInt(locationId, 10);
            }

            for (let i = 0; i < length; i++) {
                const model = this.at(i);
                const modelLocationId = model.get("location").id;

                if (locationId === modelLocationId) {
                    return i;
                }
            }
        }
        return false;
    }
}

App.Collections.MassiveSmartGeocodes = MassiveSmartGeocodeCollection;
